module.exports = __webpack_public_path__ + "img/9788994682136.3f37c93a.jpg";